import { render, staticRenderFns } from "./productSettings.vue?vue&type=template&id=2bf9caa4&scoped=true"
import script from "./productSettings.vue?vue&type=script&lang=js"
export * from "./productSettings.vue?vue&type=script&lang=js"
import style0 from "./productSettings.vue?vue&type=style&index=0&id=2bf9caa4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf9caa4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod-gz-clzjn-management-platform-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bf9caa4')) {
      api.createRecord('2bf9caa4', component.options)
    } else {
      api.reload('2bf9caa4', component.options)
    }
    module.hot.accept("./productSettings.vue?vue&type=template&id=2bf9caa4&scoped=true", function () {
      api.rerender('2bf9caa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/module/otherMarket/views/productSettings.vue"
export default component.exports